export const MEMORY_PROVIDER_DEFAULT = 'default';
export const MEMORY_PROVIDER_INFINI_MEMORY = 'infini_memory';

// Legacy mem0 uses this product-wide shared namespace, not the logged-in user's owner ID.
// The backend remains authoritative; do not switch this to the login ID without a data migration.
export const CORTEX_MEMORY_SHARED_USER_ID = 'infiniai';
